import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
  select: {
    marginRight: 5,
  },
}));

export default useStyles;
